import Snackbar from '../core/snackbar'
import i18n from '../i18n'
import router from '../router'

const state = {
  snackbar: new Snackbar()
}

const getters = {
  snackbar: (state) => {
    return state.snackbar
  }
}

const actions = {
  showMessage (context, text) {
    context.commit('showMessage', text)
  },
  hideMessage (context) {
    context.commit('hideMessage')
  },
  showHttpErrorMessage (context, e) {
    let text = 'Connection error'
    if (typeof e.response !== 'undefined') {
      switch (e.response.status) {
        case 400:
        case 409:
          text = e.response.data.message
          if (!text) {
            text = i18n.t('message.error.genericHttp', [e.response.status])
          }
          if (e.response.data) {
            text = e.response.data
          }
          break
        case 401:
          this.state.loginModule.userInfo.isAuthenticated = false
          text = i18n.t('message.error.sessionExpired')
          router.push({ path: '/login', query: { redirect: router.fullPath } })
          break
        case 404:
          text = i18n.t('message.error.notFound')
          break
        case 500:
          text = i18n.t('message.error.serverError')
          break
        default:
          text = i18n.t('message.error.genericHttp', [e.response.status])
          break
      }
    }
    context.commit('showMessage', text)
  },
  showHttpErrorLongTimeMessage (context, e) {
    let text = 'Connection error'
    if (typeof e.response !== 'undefined') {
      switch (e.response.status) {
        case 400:
        case 409:
          text = e.response.data.message
          if (!text) {
            text = i18n.t('message.error.genericHttp', [e.response.status])
          }
          if (e.response.data) {
            text = e.response.data
          }
          break
        case 401:
          this.state.loginModule.userInfo.isAuthenticated = false
          text = i18n.t('message.error.sessionExpired')
          router.push({ path: '/login', query: { redirect: router.fullPath } })
          break
        case 404:
          text = i18n.t('message.error.notFound')
          break
        case 500:
          text = i18n.t('message.error.serverError')
          break
        default:
          text = i18n.t('message.error.genericHttp', [e.response.status])
          break
      }
    }
    context.commit('showLongTimeMessage', text)
  }
}

const mutations = {
  showMessage (state, text) {
    state.snackbar.text = text
    state.snackbar.visible = true
  },
  showLongTimeMessage (state, text) {
    state.snackbar.timeout = 15000
    state.snackbar.text = text
    state.snackbar.visible = true
  },
  hideMessage (state) {
    state.snackbar.visible = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
